export default (name?: string, platform?: string): boolean =>
  (platform === 'responsive' || platform === 'progressive') && name === 'Most Popular widget';
